import { Typography } from "@circle-react-uikit/Typography";
import type { Variant } from "./types";
import { variants } from "./types";

type LabelSm = typeof Typography.LabelSm;
type LabelMd = typeof Typography.LabelMd;

export const localeRoot = "paywalls.payment_methods";

export const copyComponentMap: Record<Variant, LabelSm | LabelMd> = {
  [variants.sm]: Typography.LabelSm,
  [variants.md]: Typography.LabelSm,
  [variants.lg]: Typography.LabelSm,
  [variants.xl]: Typography.LabelMd,
};
